import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Cog } from "lucide-react";
import { COMPANY } from "../data/site";
import { OfferModal } from "./OfferModal";

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("omk_wa_seen")) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("omk_wa_seen", "1");
    }, 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <OfferModal />
    <div className="fixed bottom-6 right-6 z-[70] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.9, rotate: 3 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotate: -1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="relative w-80 border-2 border-copper/70 bg-surface shadow-2xl shadow-black/70"
            data-testid="whatsapp-popover"
          >
            {["left-1.5 top-1.5", "right-1.5 top-1.5", "left-1.5 bottom-1.5", "right-1.5 bottom-1.5"].map((p) => (
              <span key={p} className={`absolute ${p} z-10 h-1.5 w-1.5 rounded-full bg-zinc-500`} aria-hidden="true" />
            ))}

            <div className="hazard" aria-hidden="true" />

            <div className="p-5">
              <div className="flex items-center justify-between">
                <p className="font-stencil text-xs text-copper">Hotline // Text us</p>
                <button
                  onClick={() => setOpen(false)}
                  data-testid="whatsapp-popover-close"
                  aria-label="Close WhatsApp popup"
                  className="text-zinc-500 transition-colors duration-300 hover:text-zinc-200"
                >
                  <X size={16} />
                </button>
              </div>

              <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="relative flex h-2.5 w-2.5">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-60" />
                    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" />
                  </span>
                  <span className="font-mono text-[10px] tracking-widest text-green-400">FOUNDERS ONLINE NOW</span>
                </div>
                <Cog size={20} className="animate-spin-slow text-zinc-600" aria-hidden="true" />
              </div>

              <p className="mt-4 text-sm leading-relaxed text-zinc-300">
                Copper deal is live — 10% below LME prices. Text a founder directly and lock your 100 MT on WhatsApp.
              </p>

              <a
                href={COMPANY.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-pop-zambia"
                className="mt-4 flex items-center justify-between gap-3 border border-zinc-700 bg-black/40 px-4 py-3 transition-colors duration-300 hover:border-copper"
              >
                <span className="flex items-center gap-3 font-mono text-xs text-zinc-200">
                  <img src="https://flagcdn.com/w40/zm.png" alt="Zambia flag" className="h-3.5 w-5 object-cover" />
                  {COMPANY.phone}
                </span>
                <span className="font-stencil text-[9px] text-copper">ZM Line</span>
              </a>
              <a
                href={COMPANY.whatsapp2}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-pop-india"
                className="mt-2 flex items-center justify-between gap-3 border border-zinc-700 bg-black/40 px-4 py-3 transition-colors duration-300 hover:border-copper"
              >
                <span className="flex items-center gap-3 font-mono text-xs text-zinc-200">
                  <img src="https://flagcdn.com/w40/in.png" alt="India flag" className="h-3.5 w-5 object-cover" />
                  {COMPANY.phone2}
                </span>
                <span className="font-stencil text-[9px] text-copper">IN Line</span>
              </a>

              <div className="mt-5 flex items-center justify-between gap-4">
                <div className="barcode w-32" aria-hidden="true" />
                <p className="font-mono text-[9px] tracking-widest text-zinc-600">OMK-HOTLINE-24/7</p>
              </div>
            </div>

            <div className="hazard" aria-hidden="true" />
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-float-btn"
        aria-label="Chat on WhatsApp"
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-copper text-ink shadow-lg shadow-black/50 transition-colors duration-300 hover:bg-copper-light"
      >
        {!open && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-copper opacity-40" aria-hidden="true" />
        )}
        <MessageCircle size={24} className="relative" />
      </button>
    </div>
    </>
  );
};
